









import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

@Component({
  name: 'TeamMember',
  components: {}
})
export default class TeamMember extends Vue {
  @Prop() compData: any;
}
